import request from "@/utils/request";
const { ElMessage } = require("element-plus");

export default {
  name: "RoomBooking",
  data() {
    return {
      loading: true,
      judge: false,
      dialogVisible: false,
      filterClass: null,
      filterRoom: null,
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      allBookings: [],
      classOptions: [],
      roomOptions: [],
      form: {
        classId: null,
        className: "",
        dormroomId: null,
        dormroomIds: [],
        checkInDate: "",
        checkOutDate: "",
        status: 1
      },
      conflictInfo: [],
      rules: {
        classId: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
        dormroomIds: [
          { required: true, type: 'array', min: 1, message: "请选择房间", trigger: "change" },
        ],
        checkInDate: [
          { required: true, message: "请选择入住日期", trigger: "change" },
        ],
        checkOutDate: [
          { required: true, message: "请选择退房日期", trigger: "change" },
        ]
      }
    };
  },
  computed: {
    selectedCount() {
      return (this.form.dormroomIds || []).length;
    }
  },
  created() {
    this.loadClassesAndRooms().then(() => {
      this.load();
    });
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async loadClassesAndRooms() {
      await this.loadClasses();
      await this.loadRooms();
    },
    loadClasses() {
      return request.get("/classInfo/list").then((res) => {
        if (res.code === "0") {
          this.classOptions = res.data || [];
        }
      }).catch(() => {
        this.classOptions = [];
      });
    },
    handleRoomChange() {
      this.checkConflicts();
    },
    loadRooms() {
      return request.get("/room/find", {
        params: { pageNum: 1, pageSize: 1000, search: "", dormBuildId: "", isCheckedIn: 0 }
      }).then((res) => {
        if (res.code === "0") {
          this.roomOptions = res.data.records || res.data || [];
        }
      }).catch(() => {
        this.roomOptions = [];
      });
    },
    async load() {
      this.loading = true;
      request.get("/roomBooking/page", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          classId: this.filterClass,
          dormroomId: this.filterRoom
        }
      }).then((res) => {
        let records = res.data.records || res.data || [];
        // 补充班级名称和房间名称
        records = records.map(item => {
          const cls = this.classOptions.find(c => c.id === item.classId);
          const room = this.roomOptions.find(r => r.dormRoomId === item.dormroomId);
          return {
            ...item,
            className: cls ? cls.className : ('班级' + item.classId),
            roomName: room ? (room.dormBuildId + '栋-' + item.dormroomId) : item.dormroomId
          };
        });
        this.tableData = records;
        this.total = res.data.total || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    filterBookings() {
      this.currentPage = 1;
      this.load();
    },
    resetFilter() {
      this.filterClass = null;
      this.filterRoom = null;
      this.currentPage = 1;
      this.load();
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form = {
          classId: null,
          className: "",
          dormroomId: null,
          checkInDate: "",
          checkOutDate: "",
          dormroomIds: [],
          status: 1
        };
        this.conflictInfo = [];
        this.judge = false;
      });
    },
    handleClassChange(val) {
      const cls = this.classOptions.find(item => item.id === val);
      if (cls) {
        this.form.className = cls.className;
        if (cls.startDate) this.form.checkInDate = cls.startDate;
        if (cls.endDate) this.form.checkOutDate = cls.endDate;
        this.checkConflicts();
      }
    },
    checkConflicts() {
      if (!this.form.classId || !this.form.checkInDate || !this.form.checkOutDate) {
        this.conflictInfo = [];
        return;
      }
      request.get("/roomBooking/checkConflict", {
        params: {
          classId: this.form.classId,
          checkInDate: this.form.checkInDate,
          checkOutDate: this.form.checkOutDate,
          dormroomIds: (this.form.dormroomIds || []).join(',')
        }
      }).then(res => {
        this.conflictInfo = res.data || [];
      }).catch(() => {
        this.conflictInfo = [];
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.conflictInfo.length > 0) {
            this.$message.warning("存在时间冲突的房间，请先解决冲突后再提交预订");
            return;
          }
          const submitData = {
            classId: this.form.classId,
            className: this.form.className,
            dormroomIds: this.form.dormroomIds,
            checkInDate: this.form.checkInDate,
            checkOutDate: this.form.checkOutDate,
            status: this.judge ? this.form.status : 1
          };
          if (this.judge) {
            submitData.bookingId = this.form.bookingId;
          }
          if (this.judge === false) {
            request.post("/roomBooking/batchAdd", submitData).then((res) => {
              if (res.code === "0") {
                ElMessage({ message: "预订成功", type: "success" });
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({ message: res.msg, type: "error" });
              }
            });
          } else {
            request.put("/roomBooking/update", submitData).then((res) => {
              if (res.code === "0") {
                ElMessage({ message: "修改成功", type: "success" });
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({ message: res.msg, type: "error" });
              }
            });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.form.dormroomIds = [];
      this.conflictInfo = [];
      this.dialogVisible = false;
    },
    handleEdit(row) {
      this.judge = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form = {
          bookingId: row.bookingId,
          classId: row.classId,
          className: row.className,
          dormroomId: row.dormroomId,
          checkInDate: row.checkInDate,
          checkOutDate: row.checkOutDate,
          status: row.status
        };
      });
    },
    handleCancel(bookingId) {
      request.delete("/roomBooking/delete/" + bookingId).then((res) => {
        if (res.code === "0") {
          ElMessage({ message: "取消预订成功", type: "success" });
          this.load();
        } else {
          ElMessage({ message: res.msg, type: "error" });
        }
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
};
